import type { CSSProperties } from 'react';

const wrap: CSSProperties = {
  display: 'flex',
  alignItems: 'flex-end',
  gap: 6,
  minHeight: 160,
  padding: '16px 0',
  borderBottom: '1px solid #e5e7eb',
  marginBottom: 16,
  overflowX: 'auto',
};

const col: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: 36,
};

const barArea: CSSProperties = {
  height: 120,
  width: 28,
  background: '#f3f4f6',
  borderRadius: 4,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  overflow: 'hidden',
};

const barFill: CSSProperties = {
  width: '100%',
  background: '#2563eb',
  borderRadius: '0 0 4px 4px',
  minHeight: 2,
};

const label: CSSProperties = {
  fontSize: 10,
  color: '#6b7280',
  marginTop: 6,
  textAlign: 'center',
  wordBreak: 'break-all',
};

export interface ColumnDatum {
  key: string;
  label: string;
  value: number;
}

export interface SimpleColumnChartProps {
  data: ColumnDatum[];
  'data-testid'?: string;
}

/**
 * Lightweight bar chart (no extra dependencies) aligned with admin-portal table/card styling.
 */
export function SimpleColumnChart({ data, 'data-testid': testId }: SimpleColumnChartProps) {
  const max = Math.max(1, ...data.map((d) => d.value));
  return (
    <div style={wrap} data-testid={testId} aria-hidden>
      {data.map((d) => {
        const pct = (d.value / max) * 100;
        return (
          <div key={d.key} style={col}>
            <div style={barArea}>
              <div style={{ ...barFill, height: `${pct}%` }} title={`${d.value}`} />
            </div>
            <span style={label}>{d.label}</span>
          </div>
        );
      })}
    </div>
  );
}
